import React, { useEffect, useState } from "react";
import { Box, useMediaQuery } from "@mui/material";
import BrandedCouponView from "pages/SearchMedication/BrandedCouponView";
import GenericCouponView from "pages/SearchMedication/GenericCouponView";
import CouponDetailsTemplate from "components/CouponDetailsTemplate";
import MainTemplateHeader from "components/MainTemplateHeader";
import { homeActions } from "actions";
import { connect } from "react-redux";

const SelectedCouponDetails = (props) => {
  const { storeAppData } = props;
  const selectedCouponItem1 =
    JSON.parse(localStorage.getItem("selectedCouponItem")) || {};
  const [selectedCouponItem, setSelectedCouponItem] =
    useState(selectedCouponItem1);
  const storedZipData = JSON.parse(localStorage.getItem("storedZipData"));
  const matches500MaxWidth = useMediaQuery("(max-width:600px)");

  const updateSelectedPharmacy = (pharmacyData) => {
    storeAppData("genericInfo", {
      productDetailId: selectedCouponItem1?.productDetailId,
      offerId: pharmacyData?.offerId,
      insuranceId: selectedCouponItem1.insuranceId,
      pbmPharmacyLocationId: pharmacyData?.pbmPharmacyLocationId,
      pbmProductDetailId: pharmacyData?.pbmProductDetailId,
      pharmacyGroupPbmId: pharmacyData?.pharmacyGroupPbmId,
      pbmId: pharmacyData?.pbmId,
      zipCode: storedZipData.zipCode,
      quantity: selectedCouponItem1?.quantity,
    });
    setSelectedCouponItem(pharmacyData);
  };

  useEffect(() => {
    document.getElementById("appcontent").scroll(0, 0);
    if (selectedCouponItem?.pbmPharmacyLocationId) {
      storeAppData("genericInfo", {
        productDetailId: selectedCouponItem?.productDetailId,
        offerId: selectedCouponItem?.offerId,
        insuranceId: selectedCouponItem?.insuranceId,
        pbmPharmacyLocationId: selectedCouponItem?.pbmPharmacyLocationId,
        zipCode: storedZipData.zipCode,
        quantity: selectedCouponItem?.quantity,
        pbmProductDetailId: selectedCouponItem?.pbmProductDetailId,
        pharmacyGroupPbmId: selectedCouponItem?.pharmacyGroupPbmId,
        pbmId: selectedCouponItem?.pbmId,
      });
    } else {
      storeAppData("brandedInfo", {
        productDetailId: selectedCouponItem?.productDetailId,
        zipCode: selectedCouponItem?.zipCode,
        name: selectedCouponItem?.name,
        quantity: selectedCouponItem?.quantity,
        insuranceId: selectedCouponItem?.insuranceId,
        offerId: selectedCouponItem?.offerId,
      });
    }
  }, []);

  return (
    <Box>
      {selectedCouponItem && (
        <>
          {selectedCouponItem && selectedCouponItem?.pbmPharmacyLocationId ? (
            <Box>
              <CouponDetailsTemplate minHeight="300px">
                <MainTemplateHeader
                  title={selectedCouponItem1?.name}
                  backTitle={matches500MaxWidth ? false : true}
                  showSearch={true}
                  selectedDosage={selectedCouponItem1?.strength}
                  selectedQuantity={selectedCouponItem1?.quantity}
                  selectedForm={selectedCouponItem1?.form}
                />
                <GenericCouponView
                  selectedGenericItem={selectedCouponItem}
                  updateSelectedPharmacy={updateSelectedPharmacy}
                  {...props}
                />
              </CouponDetailsTemplate>
            </Box>
          ) : (
            <Box>
              <BrandedCouponView
                myCoupon={true}
                myCouponSelectedDosage={selectedCouponItem?.strength}
                myCouponSelectedQuantity={selectedCouponItem?.quantity}
                myCouponSelectedForm={selectedCouponItem?.form}
                {...props}
              />
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

const mapDispatchToProps = {
  storeAppData: (type, value) => homeActions.storeAppData(type, value),
};

export default connect(null, mapDispatchToProps)(SelectedCouponDetails);
